import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { blockItemShape } from '../../../../clients/propTypes';
import { List, Item } from './styled';

const InstructionsBlock = ({ items, ordered = true, messageValues = {} }) => {
  const intl = useIntl();

  return (
    <List as={ ordered ? 'ol' : 'ul' } $plain={ !ordered }>
      {items.map(({ id, textId }) => (
        <Item key={ id }>{intl.formatMessage({ id: textId }, messageValues)}</Item>
      ))}
    </List>
  );
};

InstructionsBlock.propTypes = {
  items: PropTypes.arrayOf(blockItemShape).isRequired,
  ordered: PropTypes.bool,
  messageValues: PropTypes.objectOf(PropTypes.string)
};

export default InstructionsBlock;
